import { render, staticRenderFns } from "./BaseInputWithError.vue?vue&type=template&id=55e672ce&"
import script from "./BaseInputWithError.vue?vue&type=script&lang=ts&"
export * from "./BaseInputWithError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports